import { Appointment } from '@dreryk/egabinet-appointment-frontend-api';

import { useCurrentPractitionerConfidentialityMode } from '~libs.shared.account';
import { visitPaths } from '~libs.desktop.shared.paths';
import { VisitEnterButton } from '~libs.desktop.shared.visit-enter';

import { useVisitDependenciesContext } from '../../../../dependencies';
import { appointmentsTranslationKeys } from '../../../../translations';
import { useVisitStartCommand } from '../useVisitStartCommand';

type StartVisitButtonProps = {
   readonly appointmentId: Appointment['id'];
   readonly disabled: boolean;
   readonly patientId: number;
   readonly onVisitAlreadyStartedFault: VoidFunction;
   readonly onAppointmentAlreadyCancelledFault: VoidFunction;
   readonly visitType?: visitPaths.VisitType;
};

export const StartVisitButton = (props: StartVisitButtonProps): JSX.Element => {
   const { accountConfigurationVerificationEventInterceptor } = useVisitDependenciesContext();
   const { executeAsync: startVisit } = useVisitStartCommand({
      confidentialityLevel: useCurrentPractitionerConfidentialityMode(),
      onVisitAlreadyStartedFault: props.onVisitAlreadyStartedFault,
      onAppointmentAlreadyCancelledFault: props.onAppointmentAlreadyCancelledFault,
      visitType: props.visitType,
   });

   return (
      <VisitEnterButton
         appointmentId={props.appointmentId}
         patientId={props.patientId}
         label={appointmentsTranslationKeys.start}
         onClick={async () =>
            startVisit({
               appointmentId: props.appointmentId,
            })
         }
         testId='startVisit'
         disabled={props.disabled}
         accountConfigurationVerificationEventInterceptor={accountConfigurationVerificationEventInterceptor}
      />
   );
};
